import { FC, useMemo, useRef, useState } from 'react';
import { toast } from 'react-toastify';

import { ModalForm } from 'components/ModalForm';
import { useModal } from 'context/ModalProvider/useModal';
import { ValidationGroup } from 'devextreme-react';
import DataSource from 'devextreme/data/data_source';
import { useCreateContractorDeliveryPriceMutation } from 'pages/Contractor/api/services';
import { ContractorDeliveryPriceCreate } from 'pages/Contractor/ContractorDeliveryPrice.entity';
import $createDataSource from 'utils/create-data-souce-instance';
import { isSuccess } from 'utils/responseStatus';

import { ContractorDeliveryPriceForm } from '../../components';
import { CONTRACTOR_DELIVERY_PRICE_CRATE } from '../../ContractorDeliveryPrice.constants';

type Props = {
  onRefresh: () => void;
  contractorId: number | string;
};

export const CreateContractorDeliveryPriceModal: FC<Props> = ({ onRefresh, contractorId }) => {
  const { hideModal } = useModal();
  const modalValidateRef = useRef<ValidationGroup>(null);

  const [form, setForm] = useState<ContractorDeliveryPriceCreate>(CONTRACTOR_DELIVERY_PRICE_CRATE);
  const [createDriverMixerSalary] = useCreateContractorDeliveryPriceMutation();

  const factoryDataStore: DataSource = useMemo(() => {
    const defaultFilter = ['parentId', '=', null];
    return $createDataSource('/v1/factory', 'id', { pageSize: 20, paginate: true, defaultFilter });
  }, []);

  const objectDataStore: DataSource = useMemo(() => {
    const defaultFilter = [['parentId', '=', null], 'and', ['type', '=', 1]];
    return $createDataSource(`/v1/ContractorObject/${contractorId}`, 'id', { defaultFilter });
  }, [contractorId]);

  const handleChange = (
    name: keyof ContractorDeliveryPriceCreate,
    value: ContractorDeliveryPriceCreate[keyof ContractorDeliveryPriceCreate],
  ) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    const isValid = modalValidateRef.current?.instance.validate().isValid;

    if (!isValid || !form) return;

    createDriverMixerSalary({ ...form, contractorId: Number(contractorId) }).then((data) => {
      if (isSuccess(data)) {
        onRefresh();
        hideModal();
        toast.success('Запись успешно создана', {
          position: 'bottom-right',
        });
      }
    });
  };

  return (
    <ModalForm
      onHidden={hideModal}
      title="Создание цены доставки"
      visible
      isLoadingSubmit={false}
      width={500}
      height="auto"
      textConfirm="Создать"
      hideOnOutsideClick={false}
      onSubmit={handleSubmit}
      ref={modalValidateRef}
    >
      <ContractorDeliveryPriceForm
        form={form}
        onChange={handleChange}
        factories={factoryDataStore}
        storeObject={objectDataStore}
        type="CREATE"
      />
    </ModalForm>
  );
};
